import React from 'react';
import {Box, styled} from '@mui/material';

const RoutesWrapperComp = styled(Box)`
    background-color: ${p=>p.theme.palette.background.default};
`;

const RoutesWrapper = props=>{
    let {children} = props;
    return <RoutesWrapperComp>
      {children}
    </RoutesWrapperComp>
};

export default RoutesWrapper;
